import React, { useEffect } from 'react';

import LinkIcon from '@mui/icons-material/Link';
import { Grid, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormInput } from 'common/components/form';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validateExternalSource from '../validateExternalSource';

import BottomActionsForm from './form/BottomActionsForm';
import SourceInfoFields from './form/SourceInfoFields';

const ExternalSourceForm = ({
    fetchExternalSources,
    handleOnClose,
    initialValues,
    isSaving,
    saveExternalSource,
    sunwiseProjectId,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validateExternalSource),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleOnClickSubmit = (values) =>
        saveExternalSource({
            successCallback: () => {
                handleOnClose();
                fetchExternalSources(sunwiseProjectId);
            },
            sunwiseProjectId,
            values,
        });

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSubmit)}>
            <Grid container>
                <Grid size={{ sm: 9, xs: 18 }}>
                    <ReactHookFormInput
                        control={control}
                        disabled={isSaving}
                        label={t('Name')}
                        name="name"
                        variant="standard"
                    />
                </Grid>

                <Grid size={{ sm: 9, xs: 18 }}>
                    <ReactHookFormInput
                        control={control}
                        disabled={isSaving}
                        label={t('Brand')}
                        name="brand"
                        variant="standard"
                    />
                </Grid>

                <Grid size={{ sm: 9, xs: 18 }}>
                    <ReactHookFormInput
                        control={control}
                        disabled={isSaving}
                        label={t('Type')}
                        name="type"
                        variant="standard"
                    />
                </Grid>

                <Grid size={{ sm: 9, xs: 18 }}>
                    <ReactHookFormInput
                        control={control}
                        disabled={isSaving}
                        label={t('Direct access link')}
                        name="url"
                        variant="standard"
                        prepend={<LinkIcon />}
                    />
                </Grid>
            </Grid>

            <SourceInfoFields control={control} disabled={isSaving} />

            <BottomActionsForm
                cancelText={t('Cancel')}
                continueText={t('Save')}
                disabled={isSaving}
                onCancel={handleOnClose}
                type="submit"
            />
        </Stack>
    );
};

ExternalSourceForm.propTypes = {
    fetchExternalSources: PropTypes.func,
    handleOnClose: PropTypes.func,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
    saveExternalSource: PropTypes.func,
    sunwiseProjectId: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValuesExternalSource,
    isSaving: selectors.getIsSavingData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchExternalSources: (params) =>
        dispatch(actions.fetchExternalSources(params)),
    saveExternalSource: (params) =>
        dispatch(actions.saveExternalSource(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExternalSourceForm);
